import {
    FETCH_ENTRY_LIST,
    FAIL_FETCH_ENTRY_LIST,
    SET_ENTRY_LIST_DATA,
    SET_ENTRY_LIST_STATE,
    RESET_ENTRY_LIST_STATE,
    CLEAR_PDF_ITEMS_Entry,
    DELETE_ENTRY_LIST,
    FAIL_DELETE_ENTRY_LIST,
    SUCCESS_DELETE_ENTRY_LIST,
    RESET_PROCESS_ERROR
} from '../actions';


import moment from 'moment';

const init = {
    /*common*/
    isFetching: false,
    error: undefined,
    isProcessError : false,

    /*data*/
    data: [],

    /*tableState*/
    sorts:[{columnName:'DenpyoNO',direction:'asc'}],
    filters : [],

    /*conditions*/
    dateType : "0",
    selectedDate : moment(),
    DenpyoNO : '',
    MakerName : '',
    OtodokesakiName : '',

    isAfterUpdate:false
};
const initialState = Object.assign({},init);

export default function entryListSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case FETCH_ENTRY_LIST:
        case DELETE_ENTRY_LIST:
            ret.isFetching = true;
            return ret;
        case FAIL_FETCH_ENTRY_LIST:
        case FAIL_DELETE_ENTRY_LIST:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SET_ENTRY_LIST_DATA:
        case SUCCESS_DELETE_ENTRY_LIST:
            ret.data = action.payload.data;
            ret.isFetching = false;
            return ret;
        case CLEAR_PDF_ITEMS_Entry:
            ret.pdfPath = undefined;
            return ret;
        case SET_ENTRY_LIST_STATE:
            return Object.assign({}, state, action.payload);
        case RESET_ENTRY_LIST_STATE:
            Object.keys(init).forEach((key)=>{
                ret[key] = init[key];
            })
            return ret;
        case RESET_PROCESS_ERROR:
            ret.isProcessError = false;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/entry-list.js